<template>
	<div class="users page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
		<el-dialog title="用户信息" :visible.sync="infoVisible" @close="infoVisible = false">
			<div class="avatar-line">
				<div class="key">用户头像：</div>
				<div class="value">
					<img :src="$pub.imageUrl+info.avatar" alt="">
				</div>
			</div>
			<div class="info-line">
				<div class="key">用户名：</div>
				<div class="value">{{info.username}}</div>
			</div>
			<div class="info-line">
				<div class="key">手机号：</div>
				<div class="value">{{info.phone}}</div>
			</div>
			<div class="info-line">
				<div class="key">电子邮箱：</div>
				<div class="value">{{info.email}}</div>
			</div>
			<div class="info-line">
				<div class="key">创建时间：</div>
				<div class="value">{{info.createTime}}</div>
			</div>
			<div class="info-line">
				<div class="key">实名认证：</div>
				<div class="value">{{info.realFlag?'已实名':'未实名'}}</div>
			</div>
			<div class="info-line">
				<div class="key">真实姓名：</div>
				<div class="value">{{info.realname}}</div>
			</div>
			<div class="info-line">
				<div class="key">身份证号：</div>
				<div class="value">{{info.identity}}</div>
			</div>
			<div class="tags">
				<div class="key">
					藏品偏好：
				</div>
				<div class="value">
					<span v-for="(item,index) in info['tags']" :key="index">{{item}}</span>
				</div>
			</div>
			<div class="address">
				<div class="key">
					收货地址：
				</div>
				<ul>
					<li v-for="(item,index) in info['address']" :key="index">
						<div class="address-name">
							{{item.receiverName}} {{item.receiverPhone}} {{item.email}}
						</div>
						<div class="address-detail">
							{{item.city + ' ' + item.addressDetail}}
						</div>
					</li>
				</ul>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'users',
		data() {
			return {
				userFormLabelWidth: '80px',
				// 页面表格相关配置
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 13,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [],
				filterValue: {},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					tableHeader: [{
							prop: 'username',
							label: '用户账号',
							width: 350
						},
						{
							prop: 'realName',
							label: '用户名',
							width: 350
						},
						{
							prop: 'createAt',
							label: '创建时间',
							width: 250
						},
						{
							prop: 'authentication',
							label: '实名状态',
							width: 250,
							template: true
						}
					],
					tableEvent: [{
						icon: 'el-icon-search',
						name: '详情',
						color: 'blue',
						sign: 'detail'
					},
					// {
					// 	icon: 'el-icon-open',
					// 	name: '修改状态',
					// 	color: 'blue',
					// 	sign: 'open'
					// },
					{
						icon: 'el-icon-delete',
						name: '删除',
						color: 'red',
						sign: 'delete'
					}],
					emptyDescription: '当前没有数据',
				},
				tableData: [],
				infoVisible: false,
				info: {
					avatar: '',
					username: '',
					phone: '',
					email: '',
					createTime: '',
					realFlag: false,
					realname: '',
					identity: '',
					tags: [],
					address: []
				},
				operationId: ''
			};
		},
		methods: {
			pageChange() {
				this.fetchData()
			},
			buttonClick(sign) {
				if (sign === 'new') {
					this.dialogFormVisible = true
				}
			},
			filterChange() {
				console.log(this.filterValue);
			},
			scopeButtonClick(row, sign) {
				this.operationId = row.userId
				if (sign === 'detail') {
					this.fetchUserInfo()
				}
				if (sign === 'open') {
					this.switchStatus(row)
				}
				if (sign === 'delete') {
					this.confirmDelete()
				}
			},
			fetchUserInfo() {
				this.$api.normalUserInfo({
					id: this.operationId
				}, res => {
					console.log(res);
					if (res.code == 200) {
						this.infoVisible = true
						this.info = {
							avatar: res.data.url,
							username: res.data.memberName,
							phone: res.data.memberPhone,
							email: res.data.memberEmail,
							createTime: res.data.createAt,
							realFlag: res.data.authentication == 1 ? true : false,
							realname: res.data.memberName,
							identity: res.data.memberIdCard,
							tags: res.data.likeLots.split(','),
							address: res.data.addressList
						}
					}
				})
			},
			switchStatus(row) {
				let status = row.userStatus
				let msg = ''
				let result = ''
				if (status == 1) {
					msg = '确认要禁用这个账号吗？'
					result = '禁用成功。'
				} else {
					msg = '确认要启用这个账号吗？'
					result = '启用成功。'
				}
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.admUserStatus({
						userId: this.operationId
					}, res => {
						this.operationId = ''
						if (res.code == 200) {
							this.fetchData()
							this.$message({
								message: result,
								type: 'success',
								duration: 2000
							})
						}
					})
				}).catch(() => {});
			},
			confirmDelete() {
				this.$confirm('确认要删除这个账号吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.admUserDelete({
						userId: this.operationId
					}, res => {
						this.operationId = ''
						if (res.code == 200) {
							this.fetchData()
							this.$message({
								message: '删除成功',
								type: 'success',
								duration: 2000
							})
						}
					})
				}).catch(() => {});
			},
			// 获取用户列表
			fetchData() {
				this.$api.normalUserList({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage
				}, res => {
					if (res.code == 200) {
						this.pageConfig.total = res.data.total
						this.tableData = res.data.list
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.upload-avatar {
		width: 100%;
		display: flex;
		margin-bottom: @vue-spacing-col-lg;

		.upload-avatar-label {
			width: 80px;
			display: flex;
			justify-content: flex-end;
			padding-right: 10px;
			box-sizing: border-box;

			span {
				color: @vue-text-color-red;
			}
		}
	}

	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		border: 1px dashed #d9d9d9;
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.avatar-line,
	.info-line,
	.tags,
	.address {
		width: 100%;
	}

	.avatar-line,
	.info-line,
		{
		display: flex;

		.key,
		.value {
			height: 100%;
			display: flex;
			align-items: center;
		}

		.key {
			width: 80px;
		}

		img {
			width: 80px;
			height: 80px;
			border-radius: @vue-border-radius-circle;
		}
	}

	.avatar-line {
		height: 100px;
	}

	.info-line {
		height: 40px;
	}

	.tags,
	.address {
		margin-top: @vue-spacing-col-base;

		.key {
			width: 100%;
			height: 40px;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-sm;
			font-weight: bold;
		}

		.value {
			display: flex;
			flex-wrap: wrap;

			span {
				height: 30px;
				padding: 0px 10px;
				border: 1px solid @vue-border-color-red;
				box-sizing: border-box;
				border-radius: 15px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-right: @vue-spacing-row-base;
				margin-bottom: 10px;
			}
		}

		li {
			margin-bottom: @vue-spacing-col-base;
		}
	}
</style>
